module.exports = __webpack_public_path__ + "static/media/login-button.cd77b1a1.svg";